import { useEffect, useRef, useState } from "react";
import Button from "../Button";
import styles from "./ExpandableText.module.scss";

interface props {
  text: string;
  className?: string;
  lines?: number;
  fontSize?: number;
  label?: string;
}

export default function ExpandableText({
  text,
  className,
  lines = 2,
  fontSize = 12,
  label,
}: props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const lineHeight = fontSize + 6;

  useEffect(() => {
    if (containerRef.current && text) {
      if (containerRef.current.clientHeight > lines * lineHeight) {
        setIsExpandable(true);
      }
    }
  }, [text, lines, lineHeight]);

  return (
    <div
      className={styles.expandableTextContainer}
      style={{ fontSize: `${fontSize}px`, lineHeight: `${lineHeight}px` }}
    >
      <div
        ref={containerRef}
        className={className}
        style={{
          wordBreak: "break-word",
          ...(isExpandable && !isExpanded
            ? {
                display: "-webkit-box",
                WebkitLineClamp: lines,
                lineClamp: lines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
            : {}),
        }}
      >
        {label && <span className={styles.label}>{label} </span>}
        {text}
      </div>
      {isExpandable && (
        <Button
          variant="link"
          size="sm"
          className={styles.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show Less" : "Show More"}
        </Button>
      )}
    </div>
  );
}
